import { createFileRoute } from '@tanstack/react-router'
import ProgramSettings from '@/pages/settings/program'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/settings/program',
)({
  // RFC-231 §6: the policy editor deep-links here when generation is blocked
  // on unanswered questions — `policy` focuses that policy's questionnaire.
  validateSearch: (search: Record<string, unknown>) => ({
    policy: typeof search.policy === 'string' ? search.policy : undefined,
  }),
  component: ProgramSettings,
})
